export function canUseSalesEnablement(user?: {
  role?: string
  is_super_admin?: boolean
  organization_name?: string | null
  can_use_sales_enablement?: boolean | null
  sales_enablement_enabled?: boolean | null
  organization_sales_enablement_enabled?: boolean | null
} | null): boolean {
  if (!user) return false

  // Organization-level disablement is the hard gate. A stale user-level flag
  // or super-admin entitlement should not keep the tenant Sales UI visible
  // after the feature is switched off in Organization Settings.
  if (user.organization_sales_enablement_enabled === false) {
    return false
  }

  if (user.is_super_admin) return true
  if (user.sales_enablement_enabled === false) return false
  const roleCanAccess = user.role === 'owner' || user.role === 'admin'
  if (user.can_use_sales_enablement !== undefined && user.can_use_sales_enablement !== null) {
    return roleCanAccess && user.can_use_sales_enablement === true
  }
  if (user.organization_sales_enablement_enabled !== undefined && user.organization_sales_enablement_enabled !== null) {
    return roleCanAccess && user.sales_enablement_enabled === true && user.organization_sales_enablement_enabled === true
  }
  return false
}

export function isMessagingAdvisoryAdmin(user?: {
  role?: string
  is_super_admin?: boolean
  organization_name?: string | null
} | null): boolean {
  if (!user) return false
  if (user.is_super_admin) return true
  const orgName = (user.organization_name || '').trim().toLowerCase()
  return orgName === 'messaging advisory' && (user.role === 'owner' || user.role === 'admin')
}

export function canUseAssetGenerator(user?: {
  role?: string
  is_super_admin?: boolean
  organization_name?: string | null
} | null): boolean {
  return isMessagingAdvisoryAdmin(user)
}
